var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 31,
    viewBox: "0 0 43 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5849 30.0123H2.41505C1.08319 30.0123 0 29.0495 0 27.8671V2.82788C0 1.64444 1.08355 0.681641 2.41505 0.681641H40.5849C41.9168 0.681641 43 1.64508 43 2.82788V27.8671C43.0004 29.0499 41.9165 30.0127 40.5846 30.0127L40.5849 30.0123ZM2.41505 1.53998C1.61614 1.53998 0.965715 2.11728 0.965715 2.8278V27.867C0.965715 28.5769 1.61613 29.1542 2.41505 29.1542H40.5849C41.3835 29.1542 42.0343 28.5769 42.0343 27.867L42.0339 2.8278C42.0339 2.11729 41.3832 1.53998 40.5846 1.53998H2.41505Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8491 25.6291V20.6657L28.452 19.166L18.9077 23.4343L10.185 22.5919L3.6748 25.6291",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8775 10.1573L37.2822 6.2434C37.206 6.13339 37.1256 6.02589 37.0417 5.9209L32.5283 9.93095L32.8775 10.1573Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1294 9.67319L36.7454 5.57095C36.6555 5.47253 36.5627 5.37789 36.4657 5.28418L31.7812 9.44692L32.1294 9.67319Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4336 7.99705L35.4264 4.44986C35.3107 4.37401 35.1911 4.30036 35.0698 4.23047L31.4339 7.46114L31.4343 7.99707L31.4336 7.99705Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4336 6.85104L34.6405 4.00244C34.509 3.93819 34.3767 3.87833 34.2406 3.82129L31.4336 6.31542L31.4336 6.85104Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4336 5.70292L33.7602 3.63563C33.6134 3.58517 33.4639 3.54035 33.3122 3.49805L31.4336 5.1673L31.4336 5.70292Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4336 4.55408L32.7704 3.36622C32.6036 3.33237 32.4336 3.30542 32.2629 3.28223L31.4336 4.01906L31.4336 4.55408Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4336 9.14537L36.1272 4.97453C36.0242 4.88677 35.9194 4.80153 35.8108 4.71973L31.4339 8.60943L31.4336 9.14537Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6237 10.6417L37.7272 6.99546C37.6661 6.87292 37.6009 6.75194 37.5311 6.63379L33.2744 10.4161L33.6237 10.6417Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M35.119 11.6115L38.2899 8.79431C38.268 8.63792 38.2419 8.48372 38.2081 8.33203L34.7715 11.385L35.119 11.6115Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3719 11.1262L38.0719 7.83911C38.0285 7.70153 37.9809 7.56582 37.9277 7.43262L34.0234 10.9017L34.3719 11.1262Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6124 12.5812L38.0815 11.2756C38.1524 11.0518 38.2088 10.8227 38.2515 10.5898L36.2646 12.3553L36.6124 12.5812Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8641 12.0972L38.3317 9.90489C38.3384 9.79426 38.3423 9.683 38.3423 9.57048C38.3423 9.50122 38.3391 9.43258 38.3367 9.36426L35.5156 11.8712L35.8641 12.0972Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2255 12.9789C37.3934 12.7448 37.5447 12.5019 37.6777 12.248L37.0117 12.8398L37.2255 12.9789Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.171 15.9164C27.2224 15.9164 24.0098 13.0625 24.0098 9.55317C24.0098 6.12504 27.077 3.32161 30.9015 3.19629V9.49115H30.9054L36.8914 13.3772H36.8903C35.5838 14.9179 33.5057 15.9164 31.171 15.9164Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44824 10.2861H18.2043V12.113H5.44824V10.2861Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44824 13.1211H15.1225V14.947H5.44824V13.1211Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44824 4.49219H16.002V6.3191H5.44824V4.49219Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44824 7.32617H15.1225V9.15332H5.44824V7.32617Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.896ce69cef977165c114a61b7a98b102.svg";
export { ForwardRef as ReactComponent };